export default "__VITE_ASSET__vq$xt2nh__"